import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { CURRENCY, CURRENCY_SYMBOL } from '../../config/const.js';

import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import FormControl from 'react-bootstrap/FormControl';
import ListGroup from 'react-bootstrap/ListGroup';
import ListGroupItem from 'react-bootstrap/ListGroupItem';
import InputGroup from 'react-bootstrap/InputGroup';
import { searchPackaging } from '../../api/PackagingApi.js';
import useInfinitePagination from '../../hooks/useInfinitePagination.js';
import Card from 'react-bootstrap/Card';
import CardDeck from 'react-bootstrap/CardDeck';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

export const FieldsPackaging = ({ children, handleSubmit, touched, errors, values, setFieldValue, setFieldTouched}) => {
  //Manage pagination
  const [search, setSearch] = useState('');
  const [next, prev, resetSearch, refreshSearch, items, totItems, loading, error] = useInfinitePagination("packaging", false, searchPackaging, search, 6, "name", "ASC");

  const startSearch = () => {
    resetSearch();
  }

  const  handleSelection = (packaging) => {
    debugger
    if (packaging === null)
    {
      setFieldValue("packagingId", null);
      setFieldValue("name", '');
      setFieldValue("supplierName", '');
      setFieldValue("piecesInPackage", 0);
      setFieldValue("availableQuantity", 0);
      setFieldValue("currencyType", CURRENCY);
      setFieldValue("currencySymbol", CURRENCY_SYMBOL);
      setFieldValue("price", 0);
      setFieldValue("priceTaxable", 0);
      setFieldValue("vat", 0);
  
    }
    else
    {
      setFieldValue("packagingId",  Number(packaging.packagingId));
      setFieldValue("name", packaging.name);
      setFieldValue("supplierName", packaging.supplierName);
      setFieldValue("piecesInPackage", Number(packaging.piecesInPackage));
      setFieldValue("availableQuantity", Number(packaging.availableQuantity));
      setFieldValue("currencyType", CURRENCY);
      setFieldValue("currencySymbol", CURRENCY_SYMBOL);
      setFieldValue("price", Number(packaging.price));
      setFieldValue("priceTaxable", Number(packaging.priceTaxable));
      setFieldValue("vat", Number(packaging.vat));
  
    }

    setFieldTouched("packagingId", true, false);
    setFieldTouched("name", true, false);
    setFieldTouched("supplierName", true, false);
    setFieldTouched("piecesInPackage", true, false);
    setFieldTouched("availableQuantity", true, false);
    setFieldTouched("currencyType", true, false);
    setFieldTouched("currencySymbol", true, false);
    setFieldTouched("price", true, false);
    setFieldTouched("priceTaxable", true, false);
    setFieldTouched("vat", true, false);
  };

    return (
      <Form onSubmit={handleSubmit}>  
      <InputGroup className="mb-3">
        <FormControl
          placeholder="Packaging"
          aria-label="Packaging"
          name="search"
          value={search}
          onChange={(e) => {setSearch(e.target.value);}}
          className={touched.packagingId && errors.packagingId ? "error" : null}
          isValid={touched.packagingId && !errors.packagingId ? true : false}
          isInvalid={touched.packagingId && errors.packagingId ? true : false}/>              
          <InputGroup.Append>
            <Button variant="outline-primary" onClick={startSearch} disabled={loading}>Cerca</Button>
          </InputGroup.Append>
          <Form.Control.Feedback type="invalid">
              {errors?.packagingId}
          </Form.Control.Feedback>
      </InputGroup>
      <Row>
      <Col>
        {values.packagingId !== null &&
        (
          <CardDeck style={{display: 'flex', flexDirection: 'column',  width:'30rem'}}>
            <Card style={{ width: '30rem', flex: 1 }} key={'packaging-selected'}>
                <Card.Body>
                  <Card.Title>{values.name}</Card.Title>
                  <Card.Subtitle className="mb-2 text-muted">quantità disponibile {values.availableQuantity}</Card.Subtitle>
                  <ListGroup variant="flush">
                    <ListGroupItem>Fornitore: {values.supplierName}  </ListGroupItem>
                    <ListGroupItem>Confezione da: {values.piecesInPackage}  </ListGroupItem>
                    <ListGroupItem>IVA: {values.vat}  </ListGroupItem>
                    <ListGroupItem>Prezzo imponibile: {values.priceTaxable}  </ListGroupItem>
                    <ListGroupItem>Prezzo ivato: {values.price}  </ListGroupItem>
                  </ListGroup>
                  <Button
                        type='button'
                        variant='danger'
                        onClick={() => handleSelection(null)}
                        className="mr-1">
                        Annulla selezione
                    </Button>                  
                </Card.Body>
              </Card>
          </CardDeck>
        )
        }
        {children}
        </Col>
        <Col>
          <CardDeck style={{display: 'flex', flexDirection: 'row', flexWrap:'wrap', justifyContent: 'flexStart'}}>
          { 
          items.map((item,index) =>  
          (
            <Card style={{ minWidth: '15rem', flex: 1, flexGrow:1 }} key={'packaging-'+index}>
              <Card.Body>
                <Card.Title>{item.name}</Card.Title>
                <Card.Subtitle className="mb-2 text-muted">quantità disponibile {item.availableQuantity}</Card.Subtitle>
                <ListGroup variant="flush">
                    <ListGroupItem>Fornitore: {item.supplierName}  </ListGroupItem>
                    <ListGroupItem>Confezione da: {item.piecesInPackage}  </ListGroupItem>
                    <ListGroupItem>IVA: {item.vat}  </ListGroupItem>
                    <ListGroupItem>Prezzo imponibile: {item.priceTaxable}  </ListGroupItem>
                    <ListGroupItem>Prezzo ivato: {item.price}  </ListGroupItem>
                  </ListGroup>
                <Button variant="outline-primary" onClick={()=> {handleSelection(item)}}>Seleziona</Button>
              </Card.Body>
            </Card>
          ))}
          </CardDeck>
          {(items.length > 0) && <p>Risultati: {totItems}</p>}
          {loading && <p>Loading...</p>}
          {error && <p>{error}</p>}
          {((items.length > 0) && (items.length < totItems)) &&
          (
            <div className="mb-2">
            <Button
              type='button'
              variant='outline-primary'
              onClick={next}
              disabled={loading}
              className="mr-1">
              Visualizza altri
            </Button>
            </div>
          )}              
        </Col>
      </Row>
    </Form>            
  );
};

